export const localStorageSupported = () => {
	return typeof localStorage !== 'undefined';
};

export const getUrlParam = (name: string): string | null => {
	if (typeof window === 'undefined') {
		return '';
	}

	const urlParams = new URLSearchParams(window.location.search);
	return urlParams.get(name);
};

export const currentUrlParamsWith = (name: string, value: string) => {
	if (typeof window === 'undefined') {
		return '';
	}

	const urlParams = new URLSearchParams(window.location.search);
	urlParams.set(name, value);
	return `?${urlParams.toString()}`;
};

export const currentUrlParamsWithout = (name: string | string[]) => {
	if (typeof window === 'undefined') {
		return '';
	}

	const urlParams = new URLSearchParams(window.location.search);
	if (!Array.isArray(name)) {
		name = [name];
	}
	name.forEach((n) => urlParams.delete(n));

	return `?${urlParams.toString()}`;
};

export function downloadData(data: string, filename: string): void {
	const url = window.URL.createObjectURL(new Blob([data]));
	const link = document.createElement('a');
	link.href = url;
	link.setAttribute('download', filename);
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
}

export async function downloadFileFromUrl(url: string, filename?: string): Promise<void> {
	if (!url) return;
	try {
		const response = await fetch(url);
		const data = await response.text();
		const name = filename || url.split('/').pop() || 'export.csv';
		downloadData(data, name.includes('.') ? name : `${name}.csv`);
	} catch {
		window.open(url, '_blank');
	}
}
